// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__skZjg","additionalInfo":"AgreementModal_additionalInfo__3E2IZ"};